import React from 'react/addons';
import $ from 'jquery';
import OnClickOutsideMixin from 'react-onclickoutside';
import cx from 'classnames';

import ClassNameMixin from 'ofs/utils/ClassNameMixin';
import Icon from 'ofs/components/common/Icon';

import Options from './Options';
import OptionWrapper from './OptionWrapper';


function noop() {}

function isDefined(value) {
  return typeof value !== 'undefined';
}

// initialise SimpleChoice component on an existing element
export function init($select, styles={}, onChange=noop) {
  // create div after select box
  var div = document.createElement('div');

  for (let rule in styles) {
    div.style[rule] = styles[rule];
  }

  $select.after(div);

  // get all options in select box
  var options = [];
  $select.find('option').each((index, el) => {
    options.push(
      <div value={$(el).val()} key={$(el).val()}>
        {$(el).text()}
      </div>
    );
  });

  // get selected value
  var value = $select.find(':selected').val();

  // get name of select box
  var name = $select.attr('name');

  // render react component
  React.render(
    <SimpleChoice name={name} defaultValue={value} onChange={onChange}>
      {options}
    </SimpleChoice>,
    div
  );

  // remove select box
  $select.remove();

  return div;
}

var SimpleChoice = React.createClass({
  mixins: [ClassNameMixin, OnClickOutsideMixin],

  propTypes: {
    children: React.PropTypes.array.isRequired,
    value: React.PropTypes.oneOfType([
      React.PropTypes.string,
      React.PropTypes.number
    ]),
    defaultValue: React.PropTypes.oneOfType([
      React.PropTypes.string,
      React.PropTypes.number
    ]),

    name: React.PropTypes.string,
    placeholder: React.PropTypes.string,
    disabled: React.PropTypes.bool,
    required: React.PropTypes.bool,
    inverse: React.PropTypes.bool,

    onChange: React.PropTypes.func
  },

  getDefaultProps() {
    return {
      onChange: noop,
      onInvalid: noop,
    };
  },

  getInitialState() {
    return {
      focus: false,
      hoverValue: null,
      chosenValue: null,

      optionPosition: null
    };
  },

  isActive() {
    return !this.props.disabled && this.state.focus;
  },

  getSelectedValue() {
    var {value, defaultValue} = this.props;
    var {chosenValue} = this.state;

    // value trumps everything
    if (typeof value !== 'undefined' && value !== null) {
      return value;
    }

    if (typeof chosenValue !== 'undefined' && chosenValue !== null) {
      return chosenValue;
    }

    return defaultValue;
  },

  getOption(value) {
    return this.props.children.find((child) => child.props.value === value);
  },

  handleClick(event) {
    event.preventDefault();

    this.setState({
      focus: !this.state.focus,
      hoverValue: null
    });
  },

  handleClickOutside() {
    if (this.isMounted()) {
      this.setState({
        focus: false,
        hoverValue: null
      });
    }
  },

  handleOptionHover(option) {
    this.setState({
      hoverValue: option.props.value
    });
  },

  handleOptionClick(option, event) {
    event.preventDefault();
    event.stopPropagation();
    this.optionsMouseDown = false;

    this.setState({
      chosenValue: option.props.value,
      focus: false,
      hoverValue: null
    }, () => {
      // Try and replicate normal dom event
      const node = React.findDOMNode(this.refs.input);
      var fakeEvent = {
        target: {
          value: option.props.value,
          getAttribute: node.getAttribute.bind(node)
        },
        option
      };
      this.props.onChange(fakeEvent);
    });
  },

  componentDidMount() {
    const {onInvalid} = this.props;
    if (process.env.NODE_ENV !== 'production') {
      /* eslint-disable no-console */
      if (this.props.value && this.props.defaultValue) {
        console.warn(`Both "value" and "defaultValue" cannot be defined at the same time. "value" will be ignored.`);
      }

      if (this.props.value && this.props.onChange === noop) {
        console.warn(`"value" is defined without an "onChange" handler. Define an "onChange" handler or use "defaultValue" for an uncontrolled input.`);
      }
      /* eslint-enable no-console */
    }
    React.findDOMNode(this.refs.input).addEventListener('invalid', onInvalid);
  },

  render() {
    var {defaultValue, value, name, placeholder, inverse, children, required} = this.props;
    var {hoverValue} = this.state;

    var selectedValue = this.getSelectedValue();
    var selectedOption = (selectedValue !== null) ? this.getOption(selectedValue) : null;

    var options = children.map((child, index) => {
      var highlightedValue = isDefined(hoverValue) && (hoverValue !== null) ? hoverValue : selectedValue;

      var key = `${index}-${child.props.value}`;

      return (
        <OptionWrapper
          selected={child.props.value === highlightedValue}
          key={key}
          onHover={this.handleOptionHover}
          onClick={this.handleOptionClick}>
          {child}
        </OptionWrapper>
      );
    });

    var label;

    if (selectedOption) {
      label = selectedOption.props.children;
    } else if (placeholder) {
      label = placeholder;
    } else {
      label = children.length > 0 ? children[0].props.children : null;
    }

    var classes = {
      'ofs-SimpleChoice': true,
      'ofs-SimpleChoice--is-open': this.isActive(),
      '-theme--dark': inverse
    };

    var valueClasses = {
      'ofs-SimpleChoice__Value': true,
      'ofs-SimpleChoice__Value--placeholder': !isDefined(defaultValue) && !isDefined(value)
    };

    return (
      <div>
        {/* note react throws warning to make this field `readOnly` - but that
            retults in the `required` validation not being respected :( */}
        <input
          name={name}
          type='text'
          value={selectedValue}
          ref='input'
          style={{position: 'absolute', width: 0}}
          tabIndex='-1'
          required={required} />
        <div
          className={this.getClassSet(classes)}
          role='listbox'
          aria-haspopup='true'
          aria-activedescendant={this.isActive()}
          tabIndex="0"
          onClick={this.handleClick}>
          <div className={cx(valueClasses)}>{label}</div>

          <div className="ofs-SimpleChoice__Arrow">
            {this.isActive() ?
              <Icon glyph="arrow" size="small" variant="up" /> :
              <Icon glyph="arrow" size="small" variant="down" />
            }
          </div>

          {this.isActive() ?
            <Options>
              {options}
            </Options> : null}
        </div>
      </div>
    );
  }
});

export default SimpleChoice;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/components/simple-choice/SimpleChoice.jsx
 **/